<template>
  <div 
    class="tool-card" 
    @mouseenter="isHovered = true" 
    @mouseleave="isHovered = false"
    @click="handleClick"
  >
    <div class="card-icon" :style="{ background: iconColor }">
      <span class="icon-text">{{ title.charAt(0) }}</span>
    </div>
    <h3 class="card-title">{{ title }}</h3>
    <!-- 主描述 -->
    <p class="card-description">{{ mainDesc }}</p>
    <!-- 额外提示行（如 * 通过电脑使用）加粗+不同颜色 -->
    <p class="card-extra" v-if="extraDesc">{{ extraDesc }}</p>
    <div class="card-arrow" v-if="link">
      <span>进入 →</span>
    </div>
    <div class="card-badge" v-if="comingSoon">开发中</div>
  </div>
</template>

<script>
export default {
  name: 'ToolCard',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      default: '#667eea'
    },
    link: {
      type: String,
      default: ''
    },
    comingSoon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHovered: false
    }
  },
  computed: {
    // 按换行符分割描述文本，最后一行作为额外提示
    mainDesc() {
      const idx = this.description.lastIndexOf('\n')
      if (idx === -1) return this.description
      return this.description.substring(0, idx)
    },
    extraDesc() {
      const idx = this.description.lastIndexOf('\n')
      if (idx === -1) return ''
      return this.description.substring(idx + 1)
    }
  },
  methods: {
    handleClick() {
      if (this.comingSoon) {
        alert('该功能正在开发中，敬请期待！')
        return
      }
      if (this.link) {
        this.$router.push(this.link).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.tool-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.tool-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transform: translateY(-100%);
  transition: transform 0.3s ease;
}

.tool-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.15);
}

.tool-card:hover::before {
  transform: translateY(0);
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: transform 0.3s ease;
}

.tool-card:hover .card-icon {
  transform: scale(1.1);
}

.icon-text {
  color: #6c4eff;
  font-size: 24px;
  font-weight: bold;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #1a1a2e;
  margin-bottom: 12px;
  line-height: 1.4;
}

.card-description {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  margin: 0;
}

.card-extra {
  font-size: 13px;
  color: #e67e22;
  font-weight: bold;
  line-height: 1.6;
  margin: 4px 0 0 0;
}

.card-arrow {
  margin-top: 15px;
  color: #667eea;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transform: translateX(-5px);
  transition: all 0.3s ease;
}

.card-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  letter-spacing: 1px;
}

.tool-card:hover .card-arrow {
  opacity: 1;
  transform: translateX(0);
}

@media (max-width: 768px) {
  .tool-card {
    padding: 20px;
  }
  
  .card-icon {
    width: 48px;
    height: 48px;
  }
  
  .icon-text {
    font-size: 20px;
  }
  
  .card-title {
    font-size: 18px;
  }
  
  .card-description {
    font-size: 13px;
  }
  
  .card-arrow {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
